import { render, staticRenderFns } from "./riskAssessmentTable.vue?vue&type=template&id=05436d2a"
import script from "./riskAssessmentTable.vue?vue&type=script&lang=js"
export * from "./riskAssessmentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports